// Frontend Firebase initialization
import { initializeApp, getApps } from 'firebase/app'
import { getAuth, onAuthStateChanged, signInAnonymously, setPersistence, browserLocalPersistence } from 'firebase/auth'

// Helper to fetch and validate required env vars
function getEnv(key: string): string {
  const value = (import.meta as any).env?.[key]
  return value
}

const config = {
  apiKey: getEnv('VITE_FIREBASE_API_KEY'),
  authDomain: getEnv('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: getEnv('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: getEnv('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnv('VITE_FIREBASE_APP_ID'),
}

// Basic sanity check to aid debugging misconfigured env
const missing = Object.entries(config)
  .filter(([, v]) => !v)
  .map(([k]) => k)

if (missing.length) {
  // eslint-disable-next-line no-console
  console.error(
    `Firebase config missing env values: ${missing.join(', ')}.\n` +
      'Ensure these are set in frontend/.env.local (prefixed with VITE_ ) and restart dev server.'
  )
}

const app = getApps().length ? getApps()[0] : initializeApp(config as any)
export const auth = getAuth(app)

// Ensure we have a Firebase auth user in the browser so Firestore rules
// that require authentication will pass. Use anonymous auth persisted locally.
export const authReady: Promise<void> = (async () => {
  try {
    await setPersistence(auth, browserLocalPersistence)
  } catch {}
  if (auth.currentUser) return
  await new Promise<void>((resolve) => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        unsub(); resolve();
      } else {
        try { await signInAnonymously(auth) } catch {}
      }
    })
  })
})()

export default app

